// extracted by mini-css-extract-plugin
module.exports = {"root":"outcome-module--root--1BkK0","label":"outcome-module--label--3AeiH","cost":"outcome-module--cost--1ZGyV","point":"outcome-module--point--2FUPF"};